import { render, staticRenderFns } from "./Table6.vue?vue&type=template&id=4fa5964e&scoped=true&"
import script from "./Table6.vue?vue&type=script&lang=js&"
export * from "./Table6.vue?vue&type=script&lang=js&"
import style0 from "./Table6.vue?vue&type=style&index=0&id=4fa5964e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa5964e",
  null
  
)

export default component.exports